import React, { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";

const TestProtocolPage: React.FC = () => {
  const { attemptId } = useParams();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (!attemptId) {
      return;
    }

    const params = new URLSearchParams();
    if (searchParams.get("print") === "1") {
      params.set("print", "1");
    }

    const query = params.toString();
    window.location.replace(
      `/api/test-protocol/${encodeURIComponent(attemptId)}/pdf${
        query ? `?${query}` : ""
      }`
    );
  }, [attemptId, searchParams]);

  return <div style={{ padding: "20px" }}>Загрузка протокола...</div>;
};

export default TestProtocolPage;
